enum TimeLocationRequired {
  GPS_REQUIRED = 'YES',
  GPS_NOT_REQUIRED = 'AUTO',
  GPS_OFF = 'NO',
}

export default TimeLocationRequired;
